import React from 'react';
import { Link } from 'react-router-dom';
import styles from './StatusPage.module.css';
import { SearchX } from 'lucide-react';

const NotFoundPage: React.FC = () => {
    return (
        <div className={styles.statusPageContainer}>
            <div className={styles.contentWrapper}>
                <div className={styles.iconWrapper}>
                    <SearchX size={64} strokeWidth={1.5} />
                </div>
                <h1 className={styles.title}>Error 404</h1>
                <p className={styles.subtitle}>Página No Encontrada</p>
                <p className={styles.description}>
                    Lo sentimos, la página que estás buscando no existe o ha sido movida.
                </p>
                <Link to="/dashboard" className={styles.actionButton}>
                    Volver al Dashboard
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;